import React, { useState } from 'react'
 
 
import SalesBroadCastMessageList from './SalesBroadCastMessageList';
import SalesBroadCastMessageForm from './SalesBroadCastMessageForm';

const SalesBroadCastMessage= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <SalesBroadCastMessageForm addForm={setFromIsShown} update={upData} />
        ) : (
          <SalesBroadCastMessageList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default SalesBroadCastMessage